import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Volume2, Star, StarOff, ChevronDown, ChevronRight, Loader } from 'lucide-react';
import apiService from '../services/apiService'; // 추가

const WordListContainer = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  
  @media (max-width: 768px) {
    border-radius: 12px;
    margin: 0 16px;
  }
`;

const WordListHeader = styled.div`
  background: #f8fafc;
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const WordListTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 10px;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const WordCount = styled.p`
  color: #6b7280;
  font-size: 16px;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const WordItem = styled.div`
  border-bottom: 1px solid #f3f4f6;
  padding: 16px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: #f8fafc;
  }

  &:last-child {
    border-bottom: none;
  }

  &.expanded {
    background-color: #f0f9ff;
    border-left: 4px solid #3b82f6;
  }
  
  @media (max-width: 768px) {
    padding: 12px;
  }
`;

const WordMainContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 8px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

const WordText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
  flex: 1;
  min-width: 0;
  
  @media (max-width: 768px) {
    font-size: 16px;
    width: 100%;
  }
`;

const WordTranslation = styled.div`
  font-size: 16px;
  color: #6b7280;
  margin-left: 12px;
  flex: 1;
  min-width: 0;
  
  @media (max-width: 768px) {
    font-size: 14px;
    margin-left: 0;
    width: 100%;
  }
`;

const WordActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: 12px;
  
  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    justify-content: flex-end;
  }
`;

const WordSubContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;

const LoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #6b7280;
  font-size: 14px;
  padding: 20px;
  text-align: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }

  &.favorite {
    color: #f59e0b;
    border-color: #f59e0b;
  }

  &.favorite:hover {
    background: #fef3c7;
  }
`;

const WordDetails = styled.div`
  margin-top: 12px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

const WordDetailsTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const WordDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const WordDetailsSection = styled.div`
  background: white;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
`;

const SectionTitle = styled.h5`
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &::before {
    content: '🤖';
    font-size: 14px;
  }
`;

const WordTagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const WordTag = styled.div`
  background: ${props => props.$type === 'similar' ? '#eff6ff' : '#fef2f2'};
  color: ${props => props.$type === 'similar' ? '#1d4ed8' : '#dc2626'};
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid ${props => props.$type === 'similar' ? '#dbeafe' : '#fecaca'};
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 120px;

  &:hover {
    background: ${props => props.$type === 'similar' ? '#dbeafe' : '#fee2e2'};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

const WordTagContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

const WordTagEnglish = styled.div`
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &::before {
    content: '🤖';
    font-size: 10px;
  }
`;

const WordTagKorean = styled.div`
  font-size: 10px;
  color: #6b7280;
  font-weight: 400;
`;

const WordTagActions = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const WordTagButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #374151;
  }

  &.favorite {
    color: #f59e0b;
  }

  &.favorite:hover {
    background: #fef3c7;
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;
`;

const EmptyIcon = styled.div`
  width: 80px;
  height: 80px;
  background: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: #9ca3af;
`;

function WordList({ words, onWordClick, onSpeak }) {
  const [expandedWords, setExpandedWords] = useState(new Set());
  const [favoriteWords, setFavoriteWords] = useState(new Set());
  const [translations, setTranslations] = useState({});
  const [loadingTranslations, setLoadingTranslations] = useState(new Set());
  const [aiSimilarWords, setAiSimilarWords] = useState({});
  const [aiAntonyms, setAiAntonyms] = useState({});
  const [wordTranslations, setWordTranslations] = useState({});
  const [loadingAI, setLoadingAI] = useState(new Set());

  // 단어가 추가될 때마다 자동으로 번역 시도 (백엔드 서비스 호출로 변경)
  useEffect(() => {
    const translateWords = async () => {
      const untranslatedWords = words.filter(
        word => !translations[word.id] && !loadingTranslations.has(word.id)
      );
      if (untranslatedWords.length === 0) return;

      setLoadingTranslations(prev => {
        const newSet = new Set(prev);
        untranslatedWords.forEach(word => newSet.add(word.id));
        return newSet;
      });

      try {
        const texts = untranslatedWords.map(word => word.text);
        // 백엔드 배치 번역 호출
        const response = await apiService.translateBatch(texts, 'KO', 'EN');
        // 응답 구조에 맞게 번역 결과 처리
        let translationResults = {};
        if (
          response &&
          response.success &&
          response.data &&
          Array.isArray(response.data.translations)
        ) {
          untranslatedWords.forEach((word, idx) => {
            translationResults[word.id] = response.data.translations[idx] || '번역 실패';
          });
        } else {
          untranslatedWords.forEach((word) => {
            translationResults[word.id] = '번역 실패';
          });
        }
        setTranslations(prev => ({
          ...prev,
          ...translationResults
        }));
      } catch (error) {
        console.error('번역 오류:', error);
        setTranslations(prev => {
          const failed = {};
          untranslatedWords.forEach(word => {
            failed[word.id] = '번역 실패';
          });
          return { ...prev, ...failed };
        });
      } finally {
        setLoadingTranslations(prev => {
          const newSet = new Set(prev);
          untranslatedWords.forEach(word => newSet.delete(word.id));
          return newSet;
        });
      }
    };

    translateWords();
    // eslint-disable-next-line
  }, [words.length]); // words.length만 의존성으로 사용하여 무한 루프 방지

  // 번역 함수(단일 단어, 유사어/반대어 번역용)
  const translateWithBackend = async (text) => {
    try {
      const response = await apiService.translateText(text, 'KO', 'EN');
      // response.translation 또는 response.translations[0] 등 백엔드 응답 구조에 따라 수정
      if (response.translation) return response.translation;
      if (Array.isArray(response.translations)) return response.translations[0];
      return '번역 실패';
    } catch (error) {
      console.error('Backend API Error:', error);
      return '번역 실패';
    }
  };

  // AI API를 통한 유사어/반대어 추출 함수 (현재는 목업)
  const getAISimilarWords = async (word) => {
    // TODO: AI API 키 설정 필요 (OpenAI, Claude, 또는 다른 AI 서비스)
    // const AI_API_KEY = 'YOUR_AI_API_KEY';
    // const response = await fetch('https://api.openai.com/v1/chat/completions', {
    //   method: 'POST',
    //   headers: {
    //     'Authorization': `Bearer ${AI_API_KEY}`,
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     model: 'gpt-3.5-turbo',
    //     messages: [
    //       {
    //         role: 'user',
    //         content: `Find 5 similar words to "${word}" in English. Return only the words separated by commas.`
    //       }
    //     ],
    //     max_tokens: 100
    //   })
    // });
    // const data = await response.json();
    // return data.choices[0].message.content.split(',').map(w => w.trim());
    
    // 현재는 AI 연결이 안 되므로 목업 데이터 반환
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(['유사1', '유사2', '유사3', '유사4', '유사5']);
      }, 800);
    });
  };

  const getAIAntonyms = async (word) => {
    // TODO: AI API 키 설정 필요
    // const AI_API_KEY = 'YOUR_AI_API_KEY';
    // const response = await fetch('https://api.openai.com/v1/chat/completions', {
    //   method: 'POST',
    //   headers: {
    //     'Authorization': `Bearer ${AI_API_KEY}`,
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     model: 'gpt-3.5-turbo',
    //     messages: [
    //       {
    //         role: 'user',
    //         content: `Find 5 antonyms (opposite words) to "${word}" in English. Return only the words separated by commas.`
    //       }
    //     ],
    //     max_tokens: 100
    //   })
    // });
    // const data = await response.json();
    // return data.choices[0].message.content.split(',').map(w => w.trim());
    
    // 현재는 AI 연결이 안 되므로 목업 데이터 반환
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(['반대1', '반대2', '반대3', '반대4', '반대5']);
      }, 800);
    });
  };

  // 유사어/반대어의 한글뜻을 가져오는 함수 (백엔드 번역 서비스 사용)
  const getWordTranslation = async (word) => {
    try {
      return await translateWithBackend(word);
    } catch (error) {
      console.error('Word translation error:', error);
      return '번역 실패';
    }
  };

  const handleWordClick = async (word) => {
    const wordId = word.id;
    const isExpanded = expandedWords.has(wordId);
    
    if (!isExpanded) {
      // 확장 상태 토글
      setExpandedWords(prev => new Set([...prev, wordId]));
      
      // AI를 통한 유사어/반대어 추출 (아직 로드되지 않은 경우에만)
      if (!aiSimilarWords[wordId] && !aiAntonyms[wordId] && !loadingAI.has(wordId)) {
        setLoadingAI(prev => new Set([...prev, wordId]));
        
        try {
          // 유사어와 반대어를 병렬로 가져오기
          const [similarWords, antonyms] = await Promise.all([
            getAISimilarWords(word.text),
            getAIAntonyms(word.text)
          ]);
          
          // 유사어와 반대어의 번역을 가져오기
          const allWords = [...similarWords, ...antonyms];
          const translationPromises = allWords.map(w => getWordTranslation(w));
          const translations = await Promise.all(translationPromises);
          
          // 번역 결과를 객체로 변환
          const translationMap = {};
          allWords.forEach((word, index) => {
            translationMap[word] = translations[index];
          });
          
          setAiSimilarWords(prev => ({
            ...prev,
            [wordId]: similarWords
          }));
          
          setAiAntonyms(prev => ({
            ...prev,
            [wordId]: antonyms
          }));
          
          setWordTranslations(prev => ({
            ...prev,
            ...translationMap
          }));
        } catch (error) {
          console.error('AI 호출 오류:', error);
          // 오류 시에도 목업 데이터 설정
          const mockSimilar = ['유사1', '유사2', '유사3', '유사4', '유사5'];
          const mockAntonyms = ['반대1', '반대2', '반대3', '반대4', '반대5'];
          const allMockWords = [...mockSimilar, ...mockAntonyms];
          
          const mockTranslations = {};
          allMockWords.forEach(word => {
            mockTranslations[word] = word.includes('유사') ? `비슷한${word.slice(-1)}` : `정반대${word.slice(-1)}`;
          });
          
          setAiSimilarWords(prev => ({
            ...prev,
            [wordId]: mockSimilar
          }));
          
          setAiAntonyms(prev => ({
            ...prev,
            [wordId]: mockAntonyms
          }));
          
          setWordTranslations(prev => ({
            ...prev,
            ...mockTranslations
          }));
        } finally {
          setLoadingAI(prev => {
            const newSet = new Set(prev);
            newSet.delete(wordId);
            return newSet;
          });
        }
      }
    } else {
      // 접기
      setExpandedWords(prev => {
        const newSet = new Set(prev);
        newSet.delete(wordId);
        return newSet;
      });
    }
  };

  const toggleFavorite = (wordId, e) => {
    e.stopPropagation(); // 부모 클릭 이벤트 방지
    const newFavorites = new Set(favoriteWords);
    if (newFavorites.has(wordId)) {
      newFavorites.delete(wordId);
    } else {
      newFavorites.add(wordId);
    }
    setFavoriteWords(newFavorites);
  };

  const handleSpeak = (text, e) => {
    e.stopPropagation(); // 부모 클릭 이벤트 방지
    onSpeak(text);
  };

  const handleWordTagSpeak = (word, e) => {
    e.stopPropagation();
    onSpeak(word);
  };

  const handleWordTagFavorite = (word, e) => {
    e.stopPropagation();
    const newFavorites = new Set(favoriteWords);
    if (newFavorites.has(word)) {
      newFavorites.delete(word);
    } else {
      newFavorites.add(word);
    }
    setFavoriteWords(newFavorites);
  };

  if (words.length === 0) {
    return (
      <EmptyState>
        <EmptyIcon>
          <BookOpen size={40} />
        </EmptyIcon>
        <h3>추출된 단어가 없습니다</h3>
        <p>이미지를 업로드하거나 텍스트를 입력해보세요.</p>
      </EmptyState>
    );
  }

  return (
    <WordListContainer>
      <WordListHeader>
        <WordListTitle>추출된 단어</WordListTitle>
        <WordCount>총 {words.length}개의 단어</WordCount>
      </WordListHeader>

      {words.map((word) => {
        const isExpanded = expandedWords.has(word.id);
        const isFavorite = favoriteWords.has(word.id);
        const isLoading = loadingTranslations.has(word.id);
        const translation = translations[word.id];
        const isLoadingAI = loadingAI.has(word.id);
        const similarWords = aiSimilarWords[word.id] || [];
        const antonyms = aiAntonyms[word.id] || [];

        return (
          <WordItem 
            key={word.id} 
            className={isExpanded ? 'expanded' : ''}
            onClick={() => handleWordClick(word)}
          >
            <WordMainContent>
              <WordText>{word.text}</WordText>
              <WordTranslation>
                {isLoading ? (
                  <LoadingIndicator>
                    <Loader size={14} />
                    번역 중...
                  </LoadingIndicator>
                ) : (
                  translation || '번역 준비 중...'
                )}
              </WordTranslation>
              <WordActions>
                <ActionButton onClick={(e) => handleSpeak(word.text, e)}>
                  <Volume2 size={16} />
                </ActionButton>
                <ActionButton 
                  onClick={(e) => toggleFavorite(word.id, e)}
                  className={isFavorite ? 'favorite' : ''}
                >
                  {isFavorite ? <Star size={16} /> : <StarOff size={16} />}
                </ActionButton>
              </WordActions>
            </WordMainContent>

            {isExpanded && (
              <WordDetails>
                <WordDetailsTitle>
                  <ChevronDown size={16} />
                  단어 상세 정보
                </WordDetailsTitle>
                
                {isLoadingAI ? (
                  <LoadingIndicator>
                    <Loader size={16} />
                    AI가 유사어와 반대어를 분석 중입니다...
                  </LoadingIndicator>
                ) : (
                  <WordDetailsGrid>
                    {similarWords.length > 0 && (
                      <WordDetailsSection>
                        <SectionTitle>유사어 (AI 추출)</SectionTitle>
                        <WordTagList>
                          {similarWords.map((similar, index) => (
                            <WordTag key={index} $type="similar">
                              <WordTagContent>
                                <WordTagEnglish>{similar}</WordTagEnglish>
                                <WordTagKorean>{wordTranslations[similar] || '번역 중...'}</WordTagKorean>
                              </WordTagContent>
                              <WordTagActions>
                                <WordTagButton 
                                  onClick={(e) => handleWordTagSpeak(similar, e)}
                                  title="발음 듣기"
                                >
                                  <Volume2 size={12} />
                                </WordTagButton>
                                <WordTagButton 
                                  onClick={(e) => handleWordTagFavorite(similar, e)}
                                  className={favoriteWords.has(similar) ? 'favorite' : ''}
                                  title="즐겨찾기"
                                >
                                  {favoriteWords.has(similar) ? <Star size={12} /> : <StarOff size={12} />}
                                </WordTagButton>
                              </WordTagActions>
                            </WordTag>
                          ))}
                        </WordTagList>
                      </WordDetailsSection>
                    )}
                    
                    {antonyms.length > 0 && (
                      <WordDetailsSection>
                        <SectionTitle>반대어 (AI 추출)</SectionTitle>
                        <WordTagList>
                          {antonyms.map((antonym, index) => (
                            <WordTag key={index} $type="antonym">
                              <WordTagContent>
                                <WordTagEnglish>{antonym}</WordTagEnglish>
                                <WordTagKorean>{wordTranslations[antonym] || '번역 중...'}</WordTagKorean>
                              </WordTagContent>
                              <WordTagActions>
                                <WordTagButton 
                                  onClick={(e) => handleWordTagSpeak(antonym, e)}
                                  title="발음 듣기"
                                >
                                  <Volume2 size={12} />
                                </WordTagButton>
                                <WordTagButton 
                                  onClick={(e) => handleWordTagFavorite(antonym, e)}
                                  className={favoriteWords.has(antonym) ? 'favorite' : ''}
                                  title="즐겨찾기"
                                >
                                  {favoriteWords.has(antonym) ? <Star size={12} /> : <StarOff size={12} />}
                                </WordTagButton>
                              </WordTagActions>
                            </WordTag>
                          ))}
                        </WordTagList>
                      </WordDetailsSection>
                    )}
                    
                    {similarWords.length === 0 && antonyms.length === 0 && !isLoadingAI && (
                      <div style={{ 
                        textAlign: 'center', 
                        padding: '20px', 
                        color: '#6b7280',
                        fontStyle: 'italic'
                      }}>
                        AI 분석 결과가 없습니다.
                      </div>
                    )}
                  </WordDetailsGrid>
                )}
              </WordDetails>
            )}
          </WordItem>
        );
      })}
    </WordListContainer>
  );
}

export default WordList;
